export const normalizeContentLanguage = (locale: string): string =>
  locale.split('-')[0].toLowerCase();
